<dx-button class="send" icon="{{ moreFilters ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}" width="100%"
  text="{{ moreFilters ? lessFiltersLabel : moreFiltersLabel }}" (onClick)="toggle();">
</dx-button>